import { computeMaxPresentValue } from '@ownup/fin-lib';
import { maxAffordability, sliderMaxRange, sliderMinDTI } from '../constants';
import { AffordamilityState } from '../types';
import { getCostModels } from './costModels';

export const createTargetDti = (state: AffordamilityState, monthlyIncome: number, dti: number) => {
  const costs = getCostModels(state);
  const targetDebt = monthlyIncome * dti;
  const targetMonthlyPayment = targetDebt - state.monthlyDebt;
  return computeMaxPresentValue({ targetMonthlyPayment, costs });
};

export const getMaxAffordability = (state: AffordamilityState, monthlyIncome: number) =>
  createTargetDti(state, monthlyIncome, maxAffordability);
export const getMinAffordability = (state: AffordamilityState, monthlyIncome: number) => {
  const max = getMaxAffordability(state, monthlyIncome);
  const twentyDTI = createTargetDti(state, monthlyIncome, sliderMinDTI);
  const ranged = max - sliderMaxRange;
  const lowerBound = Number.isNaN(twentyDTI) ? ranged : Math.min(twentyDTI, ranged);
  return Math.max(0, lowerBound);
};
// The Minimum loan size you can afford is 0 enforce that using Math.max
// We want to either target 20% DTI or a desired range based on which gives us the lower max bounds.
// This means that for people who have very little debt we'll show them a fixed range slider.
// For people with more debt we'll show them a range of 20 - 50 DTI.

export const getAffordabilityRange = (state: AffordamilityState, monthlyIncome: number) => {
  return getMaxAffordability(state, monthlyIncome) - getMinAffordability(state, monthlyIncome);
};
